import React, {Component} from 'react';
import {
    Chart,
    ChartSeries,
    ChartSeriesItem,
    ChartCategoryAxis,
    ChartCategoryAxisItem,
    ChartSeriesDefaults
} from '@progress/kendo-react-charts';
import {Grid, GridColumn as Column} from '@progress/kendo-react-grid';
import vineyards from '../../json/vineyards.json';

export default class Vineyard extends Component {

    renderGrid() {
        let data = [];
        let route = this.props.match.params["id"];
        let current = vineyards.filter(item => item.id === route);
        if (current) {
            let years = current[0].years;
            let prices = current[0].prices;
            data = years.map((year, index) => {
                return {
                    year : year,
                    price : prices[index]
                }
            });
        }
        return (
            <div>
                <Grid data={data} style={{width: '300px'}}>
                    <Column field="year" title="Année" width="150px" />
                    <Column field="price" title="Prix" width="150px"/>
                </Grid>
            </div>
        )
    }

    renderTitle() {
        let name = '?';
        let region = '?';
        let route = this.props.match.params["id"];
        let current = vineyards.filter(item => item.id === route);
        if (current) {
            name = current[0].vineyard;
            region = current[0].region;
        }
        return (
            <h2>
                {region} - {name}
            </h2>
        )
    }

    renderGraph() {
        let years = [];
        let prices = [];
        let route = this.props.match.params["id"];
        let current = vineyards.filter(item => item.id === route);
        if (current) {
            years = current[0].years;
            prices = current[0].prices;
        }
        return (
            <div>
                <Chart>
                    <ChartSeriesDefaults type="line" labels={{format: 'c'}}/>
                    <ChartCategoryAxis>
                        <ChartCategoryAxisItem categories={years}/>
                    </ChartCategoryAxis>
                    <ChartSeries>
                        <ChartSeriesItem data={prices}/>
                    </ChartSeries>
                </Chart>
            </div>
        );
    }

    render() {
        let infos = '?';
        let route = this.props.match.params["id"];
        let current = vineyards.filter(item => item.id === route);
        if (current) {
            infos = current[0].info; //.replace(/\n/g, "<br />");
        }
        return (
            <div className="analytics">
                <div>{this.renderTitle()}</div>
                <div>
                    <h3>Remarques</h3>
                    <p>{infos}</p>
                </div>
                <div className="graph">
                    {this.renderGraph()}
                </div>
                <br/>
                <div className="graph">
                    {this.renderGrid()}
                </div>
            </div>
        );
    }
}
